<template>
    <nio-modal
        name="sendPaymentLink"
        size="md"
        :title="$t('payments.sendPaymentLinkModal.title')"
        ref="modal"
        @open="onOpen"
        @opened="onOpened"
    >
        <div class="space-y-6">
            <message-builder
                appended-message="payment"
                :initial-message.sync="message"
                :selected-items="[payment]"
                ref="messageBuilder"
            />
        </div>

        <template #footer>
            <nio-button @click="close">
                {{ $t('global.general.cancel') }}
            </nio-button>

            <nio-button
                color="blue"
                :loading="$wait.is('sending.paymentLink')"
                @click="triggerSendPaymentLink"
            >
                {{ $t('global.general.send') }}
            </nio-button>
        </template>
    </nio-modal>
</template>

<script>
    import { mapActions } from 'vuex';
    import MessageBuilder from '@/components/MessageBuilder.vue';
    import MessageParsing from '@/mixins/MessageParsing.js';
    import Payment from '@/entities/Payment.js';

    export default {
        components: { MessageBuilder },

        mixins: [MessageParsing],

        data() {
            return {
                payment: new Payment(),
                message: {
                    fr: '',
                    en: '',
                },
            };
        },

        methods: {
            ...mapActions('payment', [
                'sendPaymentLink',
            ]),

            async triggerSendPaymentLink() {
                this.$wait.start('sending.paymentLink');

                this.message = this.duplicateTranslationIfEmpty(this.message);

                const payload = {
                    message: this.message,
                };

                try {
                    await this.sendPaymentLink({
                        id: this.payment.id,
                        payload,
                    });

                    this.close();

                    this.$notify.show({
                        type: 'success',
                        message: this.$t('payments.sendPaymentLinkModal.notifications.success.send'),
                    });
                } catch (error) {
                    if (error.response && [400, 422].includes(error.response.status)) {
                        this.$notify.show({
                            type: 'error',
                            message: error.response.data,
                        });
                    } else {
                        this.$notify.show({
                            type: 'error',
                            message: this.$t('payments.sendPaymentLinkModal.notifications.error.send'),
                        });
                    }
                }

                this.$wait.end('sending.paymentLink');
            },

            onOpen({ payment } = {}) {
                this.payment.fill(payment);
            },

            onOpened() {
                this.$refs.messageBuilder.focus();
            },

            onClosed() {
                this.$reset();
            },

            close() {
                this.$refs.modal.close();
            },
        },
    };
</script>
